import cls from 'classnames';
import React, { useCallback, useState } from 'react';

export interface EditPageLayoutProps {
  header: React.ReactNode;
  chatArea?: React.ReactNode;
  styles: Record<string, string>;
  text: {
    // 创建智能体
    createTitle: string;
    // 预览和调试
    previewTitle: string;
  };
  blocks: BlockProps[];
  modelSelect: React.ReactNode;
  metaAreaForm: React.ReactNode;
}

export interface BlockProps {
  styles: Record<string, string>;
  children: React.ReactNode;
  name: string;
  desc: string;
  arrow: string;
  extra?: React.ReactNode;
  destroy?: boolean;
}

function Block({ styles, children, name, desc, arrow, extra, destroy }: BlockProps) {
  const [expand, setExpand] = useState(true);
  const toggleExpand = useCallback(() => setExpand((e) => !e), []);
  return (
    <div className={styles.block}>
      <div className={styles.name} onClick={toggleExpand}>
        <img className={cls(styles.arrow, { [styles.collapse]: !expand })} src={arrow} />
        {name}
        {!!extra && <div className={styles.extra}>{extra}</div>}
      </div>

      {destroy && !expand ? null : (
        <div className="w-full" style={{ display: expand ? 'block' : 'none' }}>
          <div className={styles.desc}>{desc}</div>
          {children}
        </div>
      )}
    </div>
  );
}

export function EditPageLayout({
  header,
  styles,
  text,
  chatArea,
  blocks,
  modelSelect,
  metaAreaForm,
}: EditPageLayoutProps) {
  return (
    <div className={styles.wrapper}>
      {/* Header */}
      {header}
      <div className={styles.body}>
        {/* 创建智能体 */}
        <div className={styles.left}>
          <div className={styles.top}>
            <p className={cls(styles.title)}>{text.createTitle}</p>
            {modelSelect}
          </div>
          <div className={styles.content}>
            <div className={styles.metaArea}>{metaAreaForm}</div>
            <div className={styles.extraArea}>
              {blocks.map((props) => (
                <Block {...props} />
              ))}
            </div>
          </div>
        </div>
        {/* 预览和调试 */}
        {chatArea && <div className={styles.right}>
          <p className={cls(styles.title, styles.preview)}>{text.previewTitle}</p>
          <div className={styles.chatArea}>{chatArea}</div>
        </div>}
      </div>
    </div>
  );
}
